import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconViewEye = (props) => {
  props = Object.assign({viewBox: '0 0 32 32'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M16 24.133c-2.8 0-5.6-0.8-7.867-2.133s-4.133-3.333-5.333-5.6l-0.267-0.4 0.133-0.4c1.2-2.267 2.933-4.133 5.333-5.6s5.2-2.133 8-2.133 5.6 0.8 7.867 2.133c2.267 1.333 4.133 3.333 5.333 5.6l0.133 0.4-0.133 0.4c-1.2 2.267-2.933 4.133-5.333 5.6-2.267 1.333-5.067 2.133-7.867 2.133zM4.4 16c0.933 1.867 2.533 3.467 4.533 4.533 2.133 1.2 4.533 1.867 7.2 1.867s5.067-0.667 7.2-1.867c1.867-1.2 3.467-2.8 4.533-4.533-0.933-1.867-2.533-3.467-4.533-4.533-2.133-1.2-4.533-1.867-7.2-1.867s-5.2 0.667-7.333 1.867c-1.867 1.067-3.467 2.667-4.4 4.533z"/>
        <path d="M16 19.867c-2.133 0-3.867-1.733-3.867-3.867s1.733-3.867 3.867-3.867 3.867 1.733 3.867 3.867-1.733 3.867-3.867 3.867zM16 13.6c-1.333 0-2.4 1.067-2.4 2.4s1.067 2.4 2.4 2.4 2.4-1.067 2.4-2.4-1.067-2.4-2.4-2.4z"/>
      </g>
    </SvgIcon>
  );
};


IconViewEye.displayName = 'IconViewEye';
IconViewEye.muiName = 'SvgIcon';

export default IconViewEye;



// WEBPACK FOOTER //
// ./src/components/Icons/IconViewEye.js